import React from 'react';
import SelectList from './select-list';

class AdvancedMultiselect extends React.Component {
  state = { values: [], loaded: false };

  componentDidMount() {
    this.setState({ values: this.props.value || [], loaded: true });
  }

  handleChange = (values) => {
    const newArr = [...values];
    this.setState({ values: [...values] });
    this.props.updateValue({ target: { value: newArr, name: this.props.name } });
  }

  render() {
    const { field } = this.props;
    const { loaded, values } = this.state;
    // console.log(field, 'the field');
    // if (!field || !field.options || !field.options.length) {
    //   return null;
    // }
    if (!loaded) {
      return null;
    }

    return (
      <SelectList
        searchPlaceholder={field.searchPlaceholder}
        selectedLabel={field.selectedLabel}
        api={field.api}
        subtextFormatter={field.subtextFormatter}
        handleChange={this.handleChange}
        defaults={values}
      />
    );
  }
};

export default AdvancedMultiselect;